/* eslint-disable react-hooks/rules-of-hooks */
import React, {FC, useMemo, useState, useEffect} from "react";
import ReactDOMServer from "react-dom/server";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

import classicLink from "./classicLink.tsx";
import SpanE from "./SpanE.tsx";
import AppIcons from "./AppIcons.tsx";

import fnc from "../../libs/fnc.ts";

// {appkey, db, id, col}
type componentProps = {
  appkey:string,
  db:string,
  iid:string,
  col?:string,
  color?:string,
  backgroundColor?:string,
  style?:React.CSSProperties | CSS.Properties,
  className?:string,
  gethtml?:boolean | "true" | "false"
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const {$, rz} = window;

const localState:Array<{db:string, iid:string, data:{[key:string]:any}}> = [];

const relsRenderer:FC<componentProps> = (props) => {
  // const customStyle = (props.style ? {...props.style} : undefined);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [theme, setTheme] = useState($("html").attr("data-theme"));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lng, setLng] = useState($("html").attr("lang"));
  const [data, setData] = useState<{[key:string]:any}>({});
  const [errMsg, setErrMsg] = useState<string>("");

  const styl = useMemo<React.CSSProperties | CSS.Properties>(() => {
    const est:React.CSSProperties | CSS.Properties = {...props.style};
    let clr:string; const allc = (props.color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (props.backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [props, theme]);

  // Load data
  useEffect(() => {
    if (!props.db || !props.iid || (data && data._id)) { return }
    const localRow = localState.find((rr) => (rr.db === props.db && rr.iid === props.iid && rr.data));
    if (localRow) {
      setData(localRow.data);
    }
    else {
      rz.serverAction({appkey: props.appkey, action: "loadAuxiliaryDBs", params: {dbs: [props.db], filters: {_id: props.iid}}}).then((ans) => {
        if (ans && ans[props.db] && ans[props.db][0] && ans[props.db][0]._id === props.iid) {
          const localIndex = rz.arrFindObj(localState, {db: props.db, iid: props.iid});
          if (~localIndex) { localState[localIndex].data = ans[props.db][0] }
          else { localState.push({db: props.db, iid: props.iid, data: ans[props.db][0]}) }
          setData(ans[props.db][0]);
        }
        else { setErrMsg(" ") }
      });
    }
  }, [data, props.appkey, props.db, props.iid]);

  const cellContent = useMemo(() => {
    if (!props.db || !props.iid || !data || !data._id || errMsg) { return "" }

    // ------------------ HARD-CODE ------------------
    let title:any = "";
    if (props.db === "waybills") {
      if (!data.title) { return "" }
      const ttl = data.startDate + ": " + data.title;
      title = React.createElement(
        classicLink,
        {
          key: "rels-title-" + props.db + "-" + props.iid, id: "rels-title-" + props.db + "-" + props.iid, href: "#", onClick: () => {
            const fullPaths:Array<string> = ["modal-waybills-view-iframe", "modal-waybills-view"];
            const newStates:Array<{[key:string]:any}> = [{value: "/app/pw/waybills?iframe=true&openid=" + data._id}, {visible: true}];
            window.changeState({appkey: props.appkey, fullPath: fullPaths, newState: newStates});
          }
        },
        ttl
      );
    }
    else if (props.db === "writs") {
      const doctype = (window[props.appkey].store.pw_doctypes || []).find((ii) => ((!(data || {}).company || !ii.company || ii.company === (data || {}).company) && (ii.rowkey === (data || {}).doctype)))
      const ttl = (doctype ? rz.strFromSelectedLng({lng, ru: doctype.title_ru, en: doctype.title_en, tr: doctype.title_tr}) : "")
        + (data.category ? " [" + data.category + "] " : "")
        + " №" + data.docnumber + rz.strFromSelectedLng({lng, ru: " от ", en: " from ", tr: " itibaren "}) + data.strDate
        + (data.description ? ": " + rz.textFromHTML(data.description) : "");

      title = React.createElement(
        classicLink,
        {
          key: "rels-title-" + props.db + "-" + props.iid, id: "rels-title-" + props.db + "-" + props.iid, href: "#", onClick: () => {
            const fullPaths:Array<string> = ["modal-writs-view-iframe", "modal-writs-view"];
            const newStates:Array<{[key:string]:any}> = [{value: "/app/pw/writs?iframe=true&openid=" + data._id}, {visible: true}];
            window.changeState({appkey: props.appkey, fullPath: fullPaths, newState: newStates});
          }
        },
        ttl
      );
    }
    // -----------------------------------------------
    const fls = (data.attachments || []).filter((jj) => (jj && jj.name)), exts = fls.map((jj) => (rz.strFileExtension(jj.name)));
    const att = React.createElement(SpanE, {key: "rels-icons", className: "rz-padding-top-bottom-5"}, fls.map((ii, i) => (
      React.createElement(
        classicLink,
        {
          key: "rels-att-" + props.db + "-" + props.iid + "-" + (i + 1), id: "rels-att-" + props.db + "-" + props.iid + "-" + (i + 1), href: "#", className: "", filename: ii.name, fileurl: ii.url, fileplace: ii.place,
          onClick: () => { window[props.appkey].previewAttachmentFormShow({appkey: props.appkey, lng, file: ii}) }
        },
        React.createElement(AppIcons, {
          key: "rels-att-ico-" + (i + 1), attrs: {size: "2em", "uk-tooltip": ii.name},
          icopath: rz.switchCase([
            exts[i] === "pdf", "fa/FaRegFilePdf",
            exts[i] === "xml", "bs/BsFiletypeXml",
            exts[i] === "xls", "fa/FaRegFileExcel", exts[i] === "xlsx", "fa/FaRegFileExcel", exts[i] === "xlsm", "fa6/FaFileExcel",
            rz.arrContains(["doc", "rtf"], exts[i]), "fa/FaRegFileWord", exts[i] === "docx", "fa/FaRegFileWord", exts[i] === "docm", "fa/FaFileWord",
            exts[i] === "ppt", "fa/FaRegFilePowerpoint", exts[i] === "pptx", "fa/FaRegFilePowerpoint",
            exts[i] === "csv", "fa/FaFileCsv",
            rz.arrContains(["jpg", "jpeg", "bmp", "gif", "png", "tif", "tiff"], exts[i]), "fa/FaRegFileImage",
            rz.arrContains(["avi", "mpg", "mpeg", "mkv", "mov"], exts[i]), "fa/FaRegFileVideo",
            rz.arrContains(["mp3", "wav", "ogg"], exts[i]), "fa/FaRegFileAudio",
            rz.arrContains(["rar", "zip", "7z", "cab", "tar"], exts[i]), "fa/FaRegFileArchive",
            "ai/AiTwotoneFileUnknown"
          ])
        })
      )
    )));
    // -----------------------------------------------

    const curApp = (fnc.memorizedValues?.apps || []).find((aa) => (aa.key === props.db));
    const icopath = (curApp && curApp.icon) || "tb/TbBrandAppleNews", iconColor = (curApp && curApp.iconColor) || "gray";
    const appTooltip = (curApp && rz.strFromSelectedLng({lng, ru: curApp.title_ru, en: curApp.title_en, tr: curApp.title_tr})) || "";

    if (props?.col === "icon" || props?.col === "rels_ico") {
      return (
        <div key={"rels-div-" + props.db + "-" + props.iid} id={"rels-div-" + props.db + "-" + props.iid}>
          <AppIcons key={"rels-div-ico-" + props.db + "-" + props.iid} icopath={icopath} color={iconColor} attrs={{ size: "2em", "uk-tooltip": appTooltip }} />
        </div>
      );
    }
    if (props?.col === "db" || props?.col === "rels_db") {
      return (
        <div key={"rels-div-db-" + props.db + "-" + props.iid} id={"rels-div-db-" + props.db + "-" + props.iid}>
          {props.db}
        </div>
      );
    }
    if (props?.col === "title" || props?.col === "rels_id") {
      return (
        <div key={"rels-div-title-" + props.db + "-" + props.iid} id={"rels-div-title-" + props.db + "-" + props.iid}>
          {title}
        </div>
      );
    }
    if (props?.col === "attachments") {
      return (
        <div key={"rels-div-attachments-" + props.db + "-" + props.iid} id={"rels-div-attachments-" + props.db + "-" + props.iid}>
          {att}
        </div>
      );
    }

    return (
      <tr key={"rels-tr-" + props.db + "-" + props.iid} id={"rels-tr-" + props.db + "-" + props.iid} style={styl} className={props.className}>
        <td key={"rels-tr-" + props.db + "-" + props.iid + "-td-1"} id={"rels-tr-" + props.db + "-" + props.iid + "-td-1"} style={{width: "60px", minWidth: "60px", maxWidth: "60px", textAlign: "center", padding: "5px"}}>
          <AppIcons key={"td-ico-" + props.db + "-" + props.iid} icopath={icopath} color={iconColor} attrs={{ size: "2em", "uk-tooltip": appTooltip }} />
        </td>
        <td key={"rels-tr-" + props.db + "-" + props.iid + "-td-2"} id={"rels-tr-" + props.db + "-" + props.iid + "-td-2"} style={{width: "270px", minWidth: "270px", maxWidth: "270px", textAlign: "left", padding: "5px"}}>{title}</td>
        <td key={"rels-tr-" + props.db + "-" + props.iid + "-td-3"} id={"rels-tr-" + props.db + "-" + props.iid + "-td-3"} style={{width: "150px", minWidth: "150px", maxWidth: "150px", textAlign: "left", padding: "5px"}}>{att}</td>
      </tr>
    );
  }, [props?.col, props.db, props.iid, props.className, props.appkey, data, errMsg, lng, styl]);

  if (props?.getHTML || props?.gethtml === true || props?.gethtml === "true") {
    return ReactDOMServer.renderToStaticMarkup(cellContent);
  }

  return (cellContent);
};

export default relsRenderer;
